<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="-11.5 780.5 24 24">
    <g transform="scale(-1,1)">
      <path d="M-1.17,782.5l8.33,11.67H0.5l1.67,8.33l-8.33-11.67H0.5L-1.17,782.5z" />
    </g>
  </svg>
</template>
